import React from 'react'
import PropTypes from 'prop-types';
import Section from './Section';
import AllElements from './AllElements';

function AllSections(
    {
        values,
        formikProps,
        idPrefix,
        sectorBuyer
    }) {
    return values.map(
        ({
             title,
             description,
             id,
             type,
             elements,
         }, i) => {
            return (
                <Section
                    key={i}
                    title={title}
                    id={`${idPrefix}.${id}`}
                    formikProps={formikProps}
                    description={description}
                    disabled={type === 'disabled' && !sectorBuyer}
                >
                    <AllElements
                        id={`${idPrefix}.${id}`}
                        formikProps={formikProps}
                        elements={elements}
                        disabled={!sectorBuyer}
                    />
                </Section>
            )
        })
}

AllSections.propTypes = {
    classes: PropTypes.any,
}

export default AllSections;